import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';
import { BreadcrumbsItem } from 'core/components';

<template>
  {{pageTitle (t "page-title.access-control.users.detail")}}

  <BreadcrumbsItem
    @icon="user"
    @route="cloud.access-control.users.detail"
    @text={{t
      "components.page.access-control.users.detail.user-name-user-details"
      userName=(or
        @controller.model.userPrincipal.fullName
        @controller.model.userPrincipal.email
      )
    }}
    data-test-access-control-users-detail-breadcrumb
  />

  {{outlet}}
</template>
